import { html } from 'htm/preact'

export default function Toast({ message, isError }) {
  return html`
    <div class="toast ${isError ? 'toast--err' : ''}" role="status" aria-live="polite">
      ${message}
    </div>
  `
}